import fetch from '@/utils/fetch';
export function getSchoolTimeAllList(args) {
    let params = new URLSearchParams();

    return fetch({
        url: 'structure/schoolTime/getSchoolTimeAllList',
        method: 'POST',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/system.js